import PropTypes from 'prop-types';
import React from 'react';

import './index.scss';

const Slider = ({ value, minValue, maxValue, onValueChange, step = 1 }) => {
  return (
    <div className="slider">
      <input
        type="range"
        min={minValue}
        max={maxValue}
        value={value}
        step={step}
        onChange={e => onValueChange(e.currentTarget.value)}
      />
    </div>
  );
};

Slider.propTypes = {
  value: PropTypes.number.isRequired,
  minValue: PropTypes.string.isRequired,
  maxValue: PropTypes.number.isRequired,
  onValueChange: PropTypes.func.isRequired,
  step: PropTypes.number,
};

export default Slider;
